// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyCount":"styles_msnbcDailyCount__16URX","inner":"styles_inner__2kEZA"};